import React from "react";
import {
    View,
    Text,
    StyleSheet,
    Svg,
    Path,
    G,
    Circle,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    icon: {
        marginRight: "3px"
    },
    text: {
        fontSize: "7px",
        color: "#39b54a",
        fontWeight: "bold",
    }
});

const Icon = () => (
    <Svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 40 40">
        <G id="Passed_Icon" transform="translate(-120.477 -93.275)">
            <Circle id="Ellipse_717-7" data-name="Ellipse 717-7" cx="20" cy="20" r="20" transform="translate(120.476 93.275)" fill="#39b54a" />
            <G id="Group_5484" data-name="Group 5484" transform="translate(130.476 104.275)">
                <G id="np_like_888708_000000" transform="translate(1 1)">
                    <Path id="Path_28126" data-name="Path 28126" d="M49.875,24.262a1.392,1.392,0,0,0-1.406-1.406H44.25c-.225,0-1.013-.338-.393-1.294a12.992,12.992,0,0,0,.393-3.488,1.406,1.406,0,0,0-2.813,0A5.781,5.781,0,0,1,37.5,23.418v7.312c1.8.619,2.25,1.688,4.5,1.688H46.22a1.406,1.406,0,0,0,1.124-2.25,1.392,1.392,0,0,0,1.406-1.406,1.531,1.531,0,0,0-.338-.957,1.387,1.387,0,0,0,.9-1.294,1.531,1.531,0,0,0-.338-.957,1.355,1.355,0,0,0,.9-1.293Z" transform="translate(-31.875 -16.668)" fill="#fff" />
                    <Path id="Path_28127" data-name="Path 28127" d="M19.48,37.5H16.668v9.563h2.813a1.692,1.692,0,0,0,1.688-1.688V39.188A1.657,1.657,0,0,0,19.48,37.5Z" transform="translate(-16.668 -31.875)" fill="#fff" />
                </G>
            </G>
        </G>
    </Svg>
)

const PassedIcon = () => (
    <View style={styles.container}>
        <View style={styles.icon}>
            <Icon />
        </View>
        <Text style={styles.text}>Passed!</Text>
    </View>
);

export default PassedIcon;
